import { boy, girl, geek } from "../../assets/images";

export const testimonialData = [
  {
    image: girl,
    name: "Yaire Tally",
    title: "Co-founder Bitzu",
    message:
      "Lorem ipsum dolor sit amet, ectetur adipiscing elit. Volutpat, nunc, ibero odio lacinia faucibus mus. Egetattis in purus, erat. Urna, tortor feugiat aliquam semper. ",
  },
  {
    image: geek,
    name: "Yaire Tally",
    title: "Co-founder Bitzu",
    message:
      "Lorem ipsum dolor sit amet, ectetur adipiscing elit. Volutpat, nunc, ibero odio lacinia faucibus mus. Egetattis in purus, erat. Urna, tortor feugiat aliquam semper. ",
  },
  {
    image: boy,
    name: "Yaire Tally",
    title: "Co-founder Bitzu",
    message:
      "Lorem ipsum dolor sit amet, ectetur adipiscing elit. Volutpat, nunc, ibero odio lacinia faucibus mus. Egetattis in purus, erat. Urna, tortor feugiat aliquam semper. ",
  },
];
